import { defineMessages } from "react-intl";

const messages = defineMessages({
    termsAndConditionsLink: {
        description: "Label for link Terms and Conditions",
        defaultMessage: "Terms and Conditions"
    }
});

export default messages;
